import { render, staticRenderFns } from "./OperaShopAdminChangeWindow.vue?vue&type=template&id=af70e9b4&scoped=true"
import script from "./OperaShopAdminChangeWindow.vue?vue&type=script&lang=js"
export * from "./OperaShopAdminChangeWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaShopAdminChangeWindow.vue?vue&type=style&index=0&id=af70e9b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af70e9b4",
  null
  
)

export default component.exports